import React, { useContext } from "react";
import SupplierContext from "../../../contexts/SupplierContext";

type Props = {
    height?: number | string;
    maxWidth?: string;
    maxHeight?: string;
    lightLogo?: boolean;
};

export const WhiteLabelLogo: React.FC<Props> = (props) => {
    const supplierModel = useContext(SupplierContext);

    let signedUrl = supplierModel.White_Label_Image?.signedUrl;

    if (props.lightLogo) {
        signedUrl = supplierModel.White_Label_Light_Image?.signedUrl;
    }

    return (
        <div className={"WhiteLabelLogo"}>
            {signedUrl ? (
                <img src={signedUrl} height={props.height || "auto"} style={{ maxWidth: props.maxWidth, maxHeight: props.maxHeight || "200px" }}  />
            ) : null}
        </div>
    );
};
